import { render, staticRenderFns } from "./FormEncuestaServicio.vue?vue&type=template&id=60b835aa&scoped=true"
import script from "./FormEncuestaServicio.vue?vue&type=script&lang=ts"
export * from "./FormEncuestaServicio.vue?vue&type=script&lang=ts"
import style0 from "./FormEncuestaServicio.vue?vue&type=style&index=0&id=60b835aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b835aa",
  null
  
)

export default component.exports